import React from 'react';
import Loadable from 'react-loadable';

import { Loader } from '@topconagriculture/loader';

import { RoutesConfiguration } from '../../store/router/router.types';

export enum errorManagementRoutesPaths {
  errorManagementRoot = '/error',
}

const ErrorManagementPage = Loadable({
  loader: () => import('./ErrorManagementPage'),
  loading: () => <Loader />,
});

export const errorManagementRoutesConfig: RoutesConfiguration = {
  shared: [
    {
      path: errorManagementRoutesPaths.errorManagementRoot,
      component: ErrorManagementPage,
    },
  ],
};
